import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=05056e20&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05056e20')) {
      api.createRecord('05056e20', component.options)
    } else {
      api.reload('05056e20', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=05056e20&", function () {
      api.rerender('05056e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/components/PageHeader.vue"
export default component.exports